// this is an autogenerated file from App/Account/Topbar/Inbox/Content/MessageIndicatorIcon/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Topbar_Inbox_Content_MessageIndicatorIcon{
  notifications_users_aggregate(
    where: {
      status: { _eq: UNREAD }
      notification: { tags: { _contains: "inbox" } }
    }
  ) {
    aggregate {
      count
    }
  }
}

`